import Vue from 'vue'
import Router from 'vue-router'
// import ManageLogin from '@/manage/login'
import Index from '@/page/index'
import News from '@/page/news'
import Notice from '@/page/notice'
import Venue from '@/page/venue'
import Want from '@/page/want'
import Help from '@/page/help'
import Text from '@/page/text'
import Order from '@/page/order'
import Record from '@/page/record'
import Login from '@/page/login'
import Intro from '@/page/intro'
import NoticeInfo from '@/page/noticeInfo'
import WantMenu from '@/page/wantMenu'
import WantGuide from '@/page/wantGuide'
import WantInfo from '@/page/wantInfo'
import Mine from '@/page/mine'
import Successful from '@/page/successful'
import ApplyList from '@/page/applyList'
import ApplyInfo from '@/page/applyInfo'
import RecordInfo from '@/page/recordInfo'
import HelpMenu from '@/page/helpMenu'
import HelpForm from '@/page/helpForm'
import HelpDonate from '@/page/helpDonate'
import HelpVolunteer from '@/page/helpVolunteer'
import Time from '@/page/time'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
    },
    {
      path: '/text',
      name: 'text',
      component: Text,
    },
    {
      path: '/news',
      name: 'news',
      component: News,
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice,
    },
    {
      path: '/venue',
      name: 'venue',
      component: Venue,
    },
    {
      path: '/want',
      name: 'want',
      component: Want,
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
    },
    {
      path: '/record',
      name: 'record',
      component: Record,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/intro',
      name: 'intro',
      component: Intro,
    },
    {
      path: '/noticeInfo',
      name: 'noticeInfo',
      component: NoticeInfo,
    },
    {
      path: '/wantMenu',
      name: 'wantMenu',
      component: WantMenu,
    },
    {
      path: '/wantGuide',
      name: 'wantGuide',
      component: WantGuide,
    },
    {
      path: '/wantInfo',
      name: 'wantInfo',
      component: WantInfo,
    },
    {
      path: '/mine',
      name: 'mine',
      component: Mine,
    },
    {
      path: '/successful',
      name: 'successful',
      component: Successful,
    },
    {
      path: '/applyList',
      name: 'applyList',
      component: ApplyList,
    },
    {
      path: '/applyInfo',
      name: 'applyInfo',
      component: ApplyInfo,
    },
    {
      path: '/recordInfo',
      name: 'recordInfo',
      component: RecordInfo,
    },
    {
      path: '/helpMenu',
      name: 'helpMenu',
      component: HelpMenu,
    },
    {
      path: '/helpForm',
      name: 'helpForm',
      component: HelpForm,
    },
    {
      path: '/helpDonate',
      name: 'helpDonate',
      component: HelpDonate,
    },
    {
      path: '/helpVolunteer',
      name: 'helpVolunteer',
      component: HelpVolunteer,
    },
    {
      path: '/time',
      name: 'time',
      component: Time,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js